import { render, staticRenderFns } from "./PriceForMonths.vue?vue&type=template&id=0fa2a9b6&"
import script from "./PriceForMonths.vue?vue&type=script&lang=js&"
export * from "./PriceForMonths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports